const mailDomains = 'mailDomains';

/** Base Fetch Actions */
export const FETCH_MAIL_DOMAINS_RESPONSE = `${mailDomains}/FETCH_MAIL_DOMAINS_RESPONSE`;
export const FETCH_MAIL_DOMAINS_REQUEST = `${mailDomains}/FETCH_MAIL_DOMAINS_REQUEST`;
export const FETCH_MAIL_DOMAINS_ERROR = `${mailDomains}/FETCH_MAIL_DOMAINS_ERROR`;

/** Create Sending Domain Actions */
export const CREATE_SENDING_DOMAIN_REQUEST = `${mailDomains}/CREATE_SENDING_DOMAIN_REQUEST`;
export const CREATE_SENDING_DOMAIN_RESPONSE = `${mailDomains}/CREATE_SENDING_DOMAIN_RESPONSE`;
export const CREATE_SENDING_DOMAIN_ERROR = `${mailDomains}/CREATE_SENDING_DOMAIN_ERROR`;

/** Delete Sending Domain Actions */
export const EDIT_SENDING_DOMAIN_REQUEST = `${mailDomains}/EDIT_SENDING_DOMAIN_REQUEST`;
export const EDIT_SENDING_DOMAIN_RESPONSE = `${mailDomains}/EDIT_SENDING_DOMAIN_RESPONSE`;
export const EDIT_SENDING_DOMAIN_ERROR = `${mailDomains}/EDIT_SENDING_DOMAIN_ERROR`;

/** Delete Sending Domain Actions */
export const DELETE_SENDING_DOMAIN_REQUEST = `${mailDomains}/DELETE_SENDING_DOMAIN_REQUEST`;
export const DELETE_SENDING_DOMAIN_RESPONSE = `${mailDomains}/DELETE_SENDING_DOMAIN_RESPONSE`;
export const DELETE_SENDING_DOMAIN_ERROR = `${mailDomains}/DELETE_SENDING_DOMAIN_ERROR`;

/** Create Tracking Domain Actions */
export const CREATE_TRACKING_DOMAIN_REQUEST = `${mailDomains}/CREATE_TRACKING_DOMAIN_REQUEST`;
export const CREATE_TRACKING_DOMAIN_RESPONSE = `${mailDomains}/CREATE_TRACKING_DOMAIN_RESPONSE`;
export const CREATE_TRACKING_DOMAIN_ERROR = `${mailDomains}/CREATE_TRACKING_DOMAIN_ERROR`;

/** Update Tracking Domain Actions */
export const EDIT_TRACKING_DOMAIN_REQUEST = `${mailDomains}/EDIT_TRACKING_DOMAIN_REQUEST`;
export const EDIT_TRACKING_DOMAIN_RESPONSE = `${mailDomains}/EDIT_TRACKING_DOMAIN_RESPONSE`;
export const EDIT_TRACKING_DOMAIN_ERROR = `${mailDomains}/EDIT_TRACKING_DOMAIN_ERROR`;

/** Set Default Tracking Domain Actions */
export const SET_DEFAULT_TRACKING_DOMAIN_REQUEST = `${mailDomains}/SET_DEFAULT_TRACKING_DOMAIN_REQUEST`;
export const SET_DEFAULT_TRACKING_DOMAIN_RESPONSE = `${mailDomains}/SET_DEFAULT_TRACKING_DOMAIN_RESPONSE`;
export const SET_DEFAULT_TRACKING_DOMAIN_ERROR = `${mailDomains}/SET_DEFAULT_TRACKING_DOMAIN_ERROR`;

/** Delete Tracking Domain Actions */
export const DELETE_TRACKING_DOMAIN_REQUEST = `${mailDomains}/DELETE_TRACKING_DOMAIN_REQUEST`;
export const DELETE_TRACKING_DOMAIN_RESPONSE = `${mailDomains}/DELETE_TRACKING_DOMAIN_RESPONSE`;
export const DELETE_TRACKING_DOMAIN_ERROR = `${mailDomains}/DELETE_TRACKING_DOMAIN_ERROR`;

/** Get Deep Links Actions */
export const FETCH_DEEP_LINKS_REQUEST = `${mailDomains}/FETCH_DEEP_LINKS_REQUEST`;
export const FETCH_DEEP_LINKS_RESPONSE = `${mailDomains}/FETCH_DEEP_LINKS_RESPONSE`;
export const FETCH_DEEP_LINKS_ERROR = `${mailDomains}/GET_DEEP_LINKS_ERROR`;

/**  Create Deep Links Path Actions */
export const CREATE_DEEP_LINK_PATH_REQUEST = `${mailDomains}/CREATE_DEEP_LINK_PATH_REQUEST`;
export const CREATE_DEEP_LINK_PATH_RESPONSE = `${mailDomains}/CREATE_DEEP_LINK_PATH_RESPONSE`;
export const CREATE_DEEP_LINK_PATH_ERROR = `${mailDomains}/CREATE_DEEP_LINK_PATH_ERROR`;

/**  Edit Deep Links Path Actions */
export const EDIT_DEEP_LINK_PATH_REQUEST = `${mailDomains}/EDIT_DEEP_LINK_PATH_REQUEST`;
export const EDIT_DEEP_LINK_PATH_RESPONSE = `${mailDomains}/EDIT_DEEP_LINK_PATH_RESPONSE`;
export const EDIT_DEEP_LINK_PATH_ERROR = `${mailDomains}/EDIT_DEEP_LINK_PATH_ERROR`;

/**  Enable Deep Links Path Actions */
export const ENABLE_DEEP_LINK_PATH_REQUEST = `${mailDomains}/ENABLE_DEEP_LINK_PATH_REQUEST`;
export const ENABLE_DEEP_LINK_PATH_RESPONSE = `${mailDomains}/ENABLE_DEEP_LINK_PATH_RESPONSE`;
export const ENABLE_DEEP_LINK_PATH_ERROR = `${mailDomains}/ENABLE_DEEP_LINK_PATH_ERROR`;

/**  Upsert Android Asset Links Path Actions */
export const UPSERT_ANDROID_ASSET_LINKS_REQUEST = `${mailDomains}/UPSERT_ANDROID_ASSET_LINKS_REQUEST`;
export const UPSERT_ANDROID_ASSET_LINKS_RESPONSE = `${mailDomains}/UPSERT_ANDROID_ASSET_LINKS_RESPONSE`;
export const UPSERT_ANDROID_ASSET_LINKS_ERROR = `${mailDomains}/UPSERT_ANDROID_ASSET_LINKS_ERROR`;
